import { useEffect, useState } from "react";
import Drawer from "../../components/drawer/Drawer";
import "swiper/css";
import "swiper/css/pagination";
import styleColor from "../../assets/kits/colors/colors.module.scss";
import { MinesIcon, TrashIcon, CloseIcon, AddIcon } from "../kits/Icons/Icons";
import CustomButton from "../../components/kits/custom-button/CustomButton";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import gv from "../../assets/kits/global-variables.module.scss";
import { useNavigate } from "react-router-dom";
import useSnackBar from "../../components/kits/SnackBar/useSnackBar";
import ColorSchema from "../../assets/kits/colors";
import "./cart-item.scss";
import Items from "./Items";
import { Autoplay } from "swiper";

const CartItem = ({
  isOpen,
  setIsOpen,
  items,
  changeShoppingCartItemCount,
  shoppingListItemsFinalState,
  shopId,
  setAllprice,
  supplierName,
  heightDiv,
  finishProgress,
  errorTxt,
}) => {
  const winWidth = useWindowSize();
  const [height, setHeight] = useState(0);
  const [allPrice, setAllPrice] = useState(0);
  const [closeButton, setCloseButton] = useState(false);
  const [scrollPosition, setScrollPosition] = useState("");

  let navigate = useNavigate();
  useEffect(() => {
    let all = 0;
    items.map((item) => {
      all =
        all +
        parseInt(item.apo_info.price) * +item.current_count -
        parseInt(item.apo_info.discount) * +item.current_count;
    });
    setAllPrice(all);
    setAllprice(all);
  }, [items]);

  const handleScroll = () => {
    setScrollPosition(window.scrollY); // => scroll position
    console.log(window.scrollY);
  };

  const [trigger, Component] = useSnackBar({
    time: 50,
    className: "txt-t1-m",
    text: errorTxt,
    style: {
      bottom: 20,
      position: "fixed",
      zIndex: 100000,
      color: ColorSchema.foreground_background_me,
      backgroundColor: ColorSchema.schema_surface_light,
      borderColor: ColorSchema.foreground_surface_disable,
      width: 500,
      margin: "0 50px",
    },
  });

  useEffect(() => {
    if (errorTxt != "") {
      trigger();
    }
    // handleScroll();
    // window.addEventListener("scroll", handleScroll);
    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
    // if (
    //   items.length * 55 + 220 < winWidth.height &&
    //   winWidth.height - (items.length * 55 + 220) > 40
    // ) {
    //   setHeight(items.length * 55 + 220);
    //   setCloseButton(false);
    // } else {
    //   setHeight("100%");
    //   setCloseButton(true);
    // }
  }, [winWidth, items, items.length, errorTxt]);

  return (
    <div className="cart-item position-relative">
      {items && items.length != 0 && (
        <>
          <Drawer
            fixedChildren={
              <div
                className=" pd-b-24 pd-t-16 bg-white pd-x-20 "
                style={{ height: "88px" }}
              >
                {Component}

                <div
                  className="d-flex "
                  style={{
                    width: winWidth.width > 600 ? "560px" : "100%",
                  }}
                >
                  <div className="d-flex flex-column w-100">
                    <small
                      style={{ color: styleColor.gray_600 }}
                      className="text-secondary txt-t1-l mr-b-4"
                    >
                      قیمت نهایی
                    </small>
                    {allPrice && (
                      <strong
                        style={{ color: styleColor.gray_900 }}
                        className=" title-h4-m"
                      >
                        {allPrice.toLocaleString()} تومان
                      </strong>
                    )}
                  </div>

                  <CustomButton
                    className="pd-x-16 w-50 "
                    buttonStyle="primary"
                    state={finishProgress ? "default" : "disable"}
                    size="medium"
                    isIcon="false"
                    onClick={() => {
                      // window.location.href = `/check-out/${shopId}`;
                      navigate(`/check-out/${shopId}`);
                    }}
                  >
                    <span className="title-h4-m">تکمیل خرید</span>
                  </CustomButton>
                </div>
              </div>
            }
            isOpen={isOpen}
            onScroll={(e) => {
              setScrollPosition(e.currentTarget.scrollTop);
            }}
            onClose={() => setIsOpen(false)}
            height={
              // height
              winWidth.height -
                ((items.length + 1) * 16 + items.length * 50.4 + 166) <
              8
                ? // && items.length < 8
                  `${winWidth.height - 1}px`
                : "auto"
            }
            //(items.length+1)*16+(items.length)*50.4+166
          >
            <div
              className="demo-content pd-x-20 mr-t-16 w-100 mr-b-96"
              style={{ width: "auto" }}
            >
              <div className="d-flex justify-content-between">
                <div>
                  <h3 className=" title-h4-m">سبد خرید</h3>
                  <p className="text-secondary txt-t1-l">از {supplierName}</p>
                </div>
                <div>
                  {winWidth.height -
                    ((items.length + 1) * 16 + items.length * 50.4 + 166) <
                    100 && (
                    <button
                      className="btn"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      <CloseIcon className="txt-t1-l fs-3 " />
                    </button>
                  )}
                </div>
              </div>
              {items.map((item, index) => (
                <Items
                  key={index}
                  productName={item.product_info.title}
                  price={+item.apo_info.price - +item.apo_info.discount}
                  ProductCount={item.current_count}
                  changeShoppingCartItemCount={changeShoppingCartItemCount}
                  shoppingListItemsFinalState={shoppingListItemsFinalState}
                  inventory={item.apo_info.total_inventory_count}
                  min={item.apo_info.min_order_count}
                  step={1}
                  apo={item.apo_info}
                  shopId={shopId}
                  path={item.product_info.path}
                />
              ))}
            </div>
          </Drawer>
        </>
      )}
    </div>
  );
};

export default CartItem;
